import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { EsitoBadge, StatoBadge } from "@/components/Badges";

function NewDossier() {
  const nav = useNavigate();
  const [titolo, setTitolo] = useState("");
  const [categoria, setCategoria] = useState("Storia e misteri");
  const create = async () => {
    try {
      const r = await api.post("/admin/dossiers", { titolo, categoria, intro: "", criterio_risoluzione: "", correlati: [] });
      nav(`/admin/dossier/${r.data.id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap gap-2">
      <Input value={titolo} onChange={(e) => setTitolo(e.target.value)} placeholder="Domanda del nuovo dossier (non sì/no)" className="max-w-md rounded-xl" data-testid="new-dossier-title-input" />
      <Input value={categoria} onChange={(e) => setCategoria(e.target.value)} className="max-w-[200px] rounded-xl" data-testid="new-dossier-category-input" />
      <Button onClick={create} className="rounded-full" data-testid="new-dossier-create-button">Crea dossier</Button>
    </div>
  );
}

export function DossiersTab() {
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => { api.get("/admin/dossiers").then((r) => setList(r.data)); }, []);
  const shown = list.filter((d) => !filter || d.stato === filter);
  return (
    <div className="space-y-4">
      <NewDossier />
      <select className="luma-select max-w-xs" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="admin-dossier-filter">
        <option value="">{`Tutti (${list.length})`}</option><option value="bozza">Bozze</option><option value="pubblicato">Pubblicati</option><option value="archiviato">Archiviati</option>
      </select>
      <div className="overflow-x-auto rounded-2xl border border-border">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-left text-xs uppercase text-muted-foreground">
            <tr><th className="p-3">ID</th><th className="p-3">Domanda</th><th className="p-3">Stato</th><th className="p-3">Esiti pubbl.</th></tr>
          </thead>
          <tbody>
            {shown.map((d) => (
              <tr key={d.id} className="border-t border-border">
                <td className="p-3 font-mono text-xs">{d.id}</td>
                <td className="p-3"><Link to={`/admin/dossier/${d.id}`} className="font-semibold hover:text-primary" data-testid={`admin-dossier-link-${d.id}`}>{d.titolo}</Link></td>
                <td className="space-x-1 p-3"><StatoBadge stato={d.stato} /><EsitoBadge esito={d.esito} /></td>
                <td className="p-3">{d.n_pubblicate}/{d.n_teorie}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
